import React from 'react';
import { TimelineEvent } from './types';
import { formatDateTime, timelineIcon } from './amlUtils';

interface Props {
  events: TimelineEvent[];
}

// Временная шкала событий по кейсу (в хронологическом порядке)
const AmlTimeline: React.FC<Props> = ({ events }) => {
  const sorted = [...events].sort(
    (a, b) => new Date(b.occurredAt).getTime() - new Date(a.occurredAt).getTime()
  );

  if (sorted.length === 0) {
    return <p className="text-muted">Нет событий</p>;
  }

  return (
    <div className="aml-timeline">
      {sorted.map((evt, idx) => (
        <div key={evt.id} className="d-flex gap-3 mb-3">
          {/* Иконка + линия */}
          <div className="d-flex flex-column align-items-center">
            <span className="fs-5" title={evt.eventType}>
              {timelineIcon[evt.eventType] || '•'}
            </span>
            {idx < sorted.length - 1 && (
              <div
                style={{ width: 2, flexGrow: 1, background: '#dee2e6', marginTop: 4 }}
              />
            )}
          </div>

          {/* Контент */}
          <div className="flex-grow-1 pb-2">
            <div className="d-flex justify-content-between align-items-start">
              <span className="fw-semibold small">{evt.description}</span>
              <span className="text-muted" style={{ fontSize: '0.75rem', whiteSpace: 'nowrap', marginLeft: 8 }}>
                {formatDateTime(evt.occurredAt)}
              </span>
            </div>
            {evt.actorName && (
              <div className="text-muted" style={{ fontSize: '0.78rem' }}>
                {evt.actor === 'system' ? 'Система' : evt.actorName}
              </div>
            )}
            {evt.actor === 'system' && !evt.actorName && (
              <div className="text-muted" style={{ fontSize: '0.78rem' }}>Система</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AmlTimeline;
